export default "__VITE_ASSET__UZArZALI__"